<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.permissionManagement')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="card card_layout">
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-md-4">
                    <label class="header_text mb-3 text-dark">
                        {{username}}
                    </label>
                </div>
            </div>
            <v-data-table :headers="headers" :items="rows" :item-key="'key'" hide-actions :pagination.sync="pagination"
                class="elevation-1 table-striped">
                <template v-slot:items="props">
                    <tr>
                        <td class="text-center">{{ props.item.label }}</td>
                        <td class="text-center">
                            <v-switch v-model="props.item.allow" @change="onToggle(props.item)" />
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <div class="form-row justify-content-end mt-4">
                <div class="col-auto">
                    <button class="btn btn-outline-primary px-5 py-2 mx-2" @click="back">{{$t('shared.back')}}</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-success px-5 py-2" :disabled="saveDisabled" @click="confirmSave">{{$t('shared.save')}}</button>
                </div>
            </div>
        </div>
    </div>

    <v-dialog v-model="confirmDialog" persistent width="554">
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{$t('shared.permissionManagementSave')}}
                <div class="close__dialog">
                    <i class="fas fa-times" @click="confirmDialog=false"></i>
                </div>
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="form-row justify-content-end align-items-center">
                    <div class="col-auto">
                        <button class="btn btn-success px-5 py-2" @click="confirmDialog=false">{{$t('shared.no')}}</button>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success px-5 py-2" @click="save">{{$t('shared.yes')}}</button>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>